const SUPPORTED_SPOTIFY_TYPES = new Set([
  "track",
  "album",
  "playlist",
  "artist",
  "episode",
  "show",
]);

export function normalizeLink(raw) {
  if (!raw) return null;
  const value = String(raw).trim();
  if (!value) return null;
  if (value.startsWith("/")) return value;
  if (/^https?:\/\//i.test(value)) return value;
  if (/^spotify:/i.test(value)) return value;
  return `https://${value}`;
}

function spotifyTypeLabel(type) {
  switch (type) {
    case "track":
      return "Single";
    case "album":
      return "Projet";
    case "playlist":
      return "Playlist";
    case "artist":
      return "Artiste";
    case "episode":
      return "Episode";
    case "show":
      return "Podcast";
    default:
      return "Spotify";
  }
}

export function getSpotifyEmbed(raw) {
  const link = normalizeLink(raw);
  if (!link) return null;

  const uriMatch = link.match(/^spotify:(track|album|playlist|artist|episode|show):([a-zA-Z0-9]+)$/i);
  if (uriMatch) {
    const type = uriMatch[1].toLowerCase();
    const id = uriMatch[2];
    return {
      type,
      id,
      label: spotifyTypeLabel(type),
      originalUrl: `https://open.spotify.com/${type}/${id}`,
      embedUrl: `https://open.spotify.com/embed/${type}/${id}?utm_source=generator&theme=0`,
    };
  }

  let parsed;
  try {
    parsed = new URL(link);
  } catch {
    return null;
  }

  const host = parsed.hostname.replace(/^www\./i, "").toLowerCase();
  if (host !== "open.spotify.com") return null;

  const parts = parsed.pathname.split("/").filter(Boolean);
  const offset = parts[0]?.startsWith("intl-") ? 1 : 0;
  const type = parts[offset]?.toLowerCase();
  const id = parts[offset + 1];

  if (!SUPPORTED_SPOTIFY_TYPES.has(type) || !id) return null;

  return {
    type,
    id,
    label: spotifyTypeLabel(type),
    originalUrl: `https://open.spotify.com/${type}/${id}`,
    embedUrl: `https://open.spotify.com/embed/${type}/${id}?utm_source=generator&theme=0`,
  };
}

export function isSpotifyLink(raw) {
  return Boolean(getSpotifyEmbed(raw));
}
